package cc.easyandroid.easycompose.component

import cc.easyandroid.easycompose.component.instancekeeper.attachTo
import cc.easyandroid.easycompose.core.backhandler.BackDispatcher
import cc.easyandroid.easycompose.core.backhandler.BackHandler
import cc.easyandroid.easycompose.core.instancekeeper.InstanceKeeper
import cc.easyandroid.easycompose.core.instancekeeper.InstanceKeeperDispatcher
import cc.easyandroid.easycompose.core.lifecycle.Lifecycle
import cc.easyandroid.easycompose.core.statekeeper.StateKeeper
import cc.easyandroid.easycompose.core.statekeeper.StateKeeperDispatcher

/**
 * A default implementation of the [ComponentContext] interface.
 * Can be also used in tests.
 */
class DefaultComponentContext(
    override val lifecycle: Lifecycle,
    stateKeeper: StateKeeper? = null,
    instanceKeeper: InstanceKeeper? = null,
    backHandler: BackHandler? = null,
) : ComponentContext {

    override val stateKeeper: StateKeeper = stateKeeper ?: StateKeeperDispatcher()
    override val instanceKeeper: InstanceKeeper = instanceKeeper ?: InstanceKeeperDispatcher().attachTo(lifecycle)
    override val backHandler: BackHandler = backHandler ?: BackDispatcher()
    override val componentContextFactory: ComponentContextFactory<ComponentContext> =
        ComponentContextFactory(::DefaultComponentContext)

    constructor(lifecycle: Lifecycle) : this(
        lifecycle = lifecycle,
        stateKeeper = null,
        instanceKeeper = null,
        backHandler = null,
    )
}
